import * as React from 'react';
import { Activity, Message, User, CardAction, Attachment } from 'botframework-directlinejs';

export interface EscalationInfoProps {
    message: Message;
    candidates: string[];
    onShow: () => void;
    onCardAction: (type: string, value: string) => void;
}

export interface EscalationInfoState {
    escalationInfoEntitiy: any;
}

var timeout_id:any;

export class EscalationInfoView extends React.Component<EscalationInfoProps,EscalationInfoState > {

    constructor(props: EscalationInfoProps,state: EscalationInfoState) {
        super(props);

        this.state = {
            escalationInfoEntitiy : (this.props.message.entities || []).find((x) => x.escalationInfo)
        }
    }

    //エスカレーションコマンド送信
    sendEscalationCmd(that:any, value:string){
        let contactID:string;
        //cookie取得
        var r = document.cookie.split(';');
        r.forEach(function(values){
            //cookie名と値に分ける
            var content = values.split('=');
            if(content[0].trim() == "escalationInfoEntitiy"){
                contactID = JSON.parse(decodeURIComponent(content[1]) || "{}").contactID;
            }
        });
        if(contactID){
            var Promise1 = new Promise (function ( resolve, reject ) {
                //大塚ログイン状況取得
                let otsuuLoginStateRequestURL = "https://mypage.otsuka-shokai.co.jp/GetLoginUserInfo";
                var xhr = new XMLHttpRequest();
                xhr.open("GET", otsuuLoginStateRequestURL, true);
                xhr.send(null);
                xhr.onerror = function(){
                    document.cookie = "otsuuLoginState=false";
                    resolve();
                };
                xhr.onload = function(){
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        let data:any = JSON.parse(xhr.responseText);
                        //ログイン状況をセッションに保存
                        if(data.result == "0"){
                            document.cookie = "otsuuLoginState=true";
                        }else{
                            document.cookie = "otsuuLoginState=false";
                        }
                        resolve();
                    }
                };
            });
            var Promise2 = new Promise (function ( resolve, reject ) {
                //有人チャット対応可能人数取得
                let interPersonalChatStatusRequestURL = "https://bcvipjp02.rightnowtech.com/Chat/chat/otsuka_shokai__tst1?";
                let queue_id = "queue_id=" + contactID;
                let option ="&pool=6603:4&action=PROACTIVE_QUERY&avail_type=agents&p_db_name=otsuka_shokai__pro&p_intf_id=1&responseType=JSON&callback=rntJSONspac_0";
                var xhrc = new XMLHttpRequest();
                xhrc.open("GET", interPersonalChatStatusRequestURL + queue_id + option, true);
                xhrc.send(null);
                xhrc.onerror = function(){
                    document.cookie = "interPersonalChatStatus=false";
                    resolve();
                };
                xhrc.onload = function(){
                    if (xhrc.readyState == 4 && xhrc.status == 200) {
                        let tmpXhrc:any = xhrc;
                        var data =  JSON.parse(tmpXhrc.responseText.match("\{.+?\}"));
                        if(data.availableAgentSessions > 0){
                            document.cookie = "interPersonalChatStatus=true";
                        }else{
                            document.cookie = "interPersonalChatStatus=false";
                        }
                        resolve();
                    }
                };
            });
            Promise.all([Promise1,Promise2]).then(function(){
                //cookie情報取得
                let interPersonalChatStatus = false;
                var r = document.cookie.split(';');
                r.forEach(function(value){
                    //cookie名と値に分ける
                    var content = value.split('=');
                    if(content[0].trim() == "interPersonalChatStatus"){
                        interPersonalChatStatus = (decodeURIComponent(content[1]).toLowerCase() == "true") ? true : false;
                    }
                });
                if(interPersonalChatStatus){
                    that.props.onCardAction("postBack", value);
                }
            });
        }
    }

    render() {

        if (!this.state.escalationInfoEntitiy) {
            return null;
        }
        //エンティティ情報取得
        let entitiy = this.state.escalationInfoEntitiy.escalationInfo;
        //有人チャット遷移条件をcookiesに保存
        var Cookies = "escalationInfoEntitiy=" + encodeURIComponent(JSON.stringify(entitiy));
        document.cookie = Cookies;

        //会話IDをcookieに保存
        var conversationID = "conversationID=" + this.props.message.conversation.id;
        document.cookie = conversationID + ";path=/";
        //チャットアスクタイプをcookieに保存
        var chat_ask_type = "chat_ask_type=" + entitiy.contactID;
        document.cookie = chat_ask_type + ";path=/";
        //トークンをcookieに保存
        let doc:any = document;
        var conversationID = "bearerToken=" + (doc.CHATBOT_OTS.secret || doc.CHATBOT_OTS.config.secret);
        document.cookie = conversationID + ";path=/";

        //cookie情報取得
        let escalation_flg = false;
        let same_answer_count = 0;
        var r = document.cookie.split(';');
        r.forEach(function(value){
            //cookie名と値に分ける
            var content = value.split('=');
            if(content[0].trim() == "same_answer_count"){
                same_answer_count = Number(decodeURIComponent(content[1]));
            }else if(content[0].trim() == "escalation_flg"){
                escalation_flg = (decodeURIComponent(content[1]).toLowerCase() == "true") ? true : false;
            }
        });
        //指定時間後有人チャット遷移キャンセル
        if(timeout_id !== null){
            // setTimeout() メソッドの動作をキャンセルする
            clearTimeout(timeout_id);
            timeout_id = null;
        }

        var overConversationWait = function(that:any){
            //指定時間無会話状態超過
            let value = JSON.stringify({
                "cmd": "guideToRightNow",
                "value": "conversation_wait"
            });
            that.sendEscalationCmd(that, value);
        };

        //エスカレーションのループを回避
        if(!escalation_flg){
            if ((entitiy.search_result || entitiy.search_result === 0) &&           //nullチェック(0は許容)
                (entitiy.hit_count || entitiy.hit_count === 0) &&                   //nullチェック(0は許容)
                (Number(entitiy.hit_count) <= Number(entitiy.search_result))) {     //条件を満たすか判定
                //FAQ検索結果不足
                let value = JSON.stringify({
                    "cmd": "guideToRightNow",
                    "value": "search_result"
                });
                this.sendEscalationCmd(this, value);
            }else if(entitiy.same_answer && Number(entitiy.same_answer) <= Number(same_answer_count)){
                //カウント数超過
                //カウント数をクリア
                document.cookie = "same_answer_count=0";
                let value = JSON.stringify({
                    "cmd": "guideToRightNow",
                    "value": "same_answer"
                });
                this.sendEscalationCmd(this, value);
            }else if(entitiy.conversation_wait!=null){
                let test = (Number(entitiy.conversation_wait)*1000)
                timeout_id = setTimeout(function(){overConversationWait(this)}.bind(this), (Number(entitiy.conversation_wait)*1000));
            }
        }

        const escalationInfoComponent = (() =>{
            return ("");
        })();

        return (
            <div>
            {escalationInfoComponent}
            </div>
        );
   }

}


// WEBPACK FOOTER //
// ./src/EscalationInfo.tsx